import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { getClientInfo } from '@app/shared/utils/client-info.util';
import { from, Observable, switchMap } from 'rxjs';
import { X_HOHR_CLIENT_PLATFORM, X_HOHR_CLIENT_VERSION } from '../core.constants';

export const clientInfoInterceptor: HttpInterceptorFn = (
    httpRequest: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> =>
    from(getClientInfo()).pipe(
        switchMap(({ version, platform }) =>
            next(
                httpRequest.clone({
                    setHeaders: {
                        [X_HOHR_CLIENT_VERSION]: version,
                        [X_HOHR_CLIENT_PLATFORM]: platform,
                    },
                })
            )
        )
    );
